module.exports = __webpack_public_path__ + "static/media/8.abf8db43.png";